export const selectThresholds = (state: IGlobalState) => state.thresholds.thresholds
